import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment';
import { datetime, getIsoDate, isoDateHasTime } from './util.js';

Vue.use(Vuex);

function parseOrigins(events) {
    const origins = {};

    events.forEach((event) => {
        const id = event._originId;

        origins[id] = {
            id : id,
            enabled : true,
            label : event._origin
        };
    });

    return origins;
}

export class Store {
    getStore() {
        return this.store;
    }

    async load(src) {
        const req = await window.fetch(src);
        const data = await req.json();

        function getInitialState() {
            return {
                allEvents : data,
                dateIndex : 0,
                onlyFreeEvents : false,
                origins : parseOrigins(data),
                showPastEvents : false
            };
        }

        this.store = new Vuex.Store({
            state : getInitialState(),

            getters : {
                allOriginsEnabled(state, getters) {
                    const len = Object.values(state.origins).length;
                    return len === getters.enabledOrigins.length;
                },

                date(state) {
                    return getIsoDate(state.dateIndex).slice(0, 10);
                },

                dates() {
                    return [0, 1, 2].map((index) => {
                        const date = getIsoDate(index);

                        return {
                            index : index,
                            label : datetime(date).dateFormatted
                        }
                    });
                },

                dateFormatted(state, getters) {
                    return datetime(getters.date).moment.format('dddd D MMMM');
                },

                dayFull(state, getters) {
                    return datetime(getters.date).moment.format('dddd');
                },

                enabledOrigins(state) {
                    return Object.values(state.origins)
                        .filter(o => o.enabled)
                        .map(o => o.id);
                },

                feed(state, getters) {
                    const now = moment();

                    return state.allEvents.filter((item) => {
                        // First check: do we have a startDate and is that
                        // the date selected?
                        const valid = item && item.startDate && item.startDate.startsWith(getters.date);

                        if (!valid) {
                            return false;
                        }

                        // Second check: is the origin in the enabledOrigins?
                        if (!getters.enabledOrigins.includes(item._originId)) {
                            return false;
                        }

                        // Third check: if onlyFreeEvents is true, only show
                        // events that are isAccessibleForFree
                        if (state.onlyFreeEvents && !item.isAccessibleForFree) {
                            return false;
                        }

                        // Fourth check: if showPastEvents is false, also
                        // check if the event is in the past
                        if (state.showPastEvents) {
                            return true;
                        } else {
                            // If the event has no time it's okay
                            if (!isoDateHasTime(item.startDate)) {
                                return true;
                            }

                            return now.isBefore(item.startDate);
                        }
                    }).sort((a, b) => {
                        // Items without starttime go at the bottom
                        if (!isoDateHasTime(a.startDate)) {
                            return 1;
                        }

                        return a.startDate < b.startDate ? -1 : 1;
                    }).map((item) => {
                        // Remove all images because of copyright reasons
                        item.image = false;
                        return item;
                    });
                }
            },

            mutations : {
                dateIndex(state, index) {
                    state.dateIndex = index;
                },

                onlyFreeEvents(state, bool) {
                    state.onlyFreeEvents = bool;
                },

                setAllOriginsEnabled(state, bool) {
                    Object.values(state.origins).forEach((origin) => {
                        origin.enabled = bool;
                    });
                },

                showPastEvents(state, bool) {
                    state.showPastEvents = bool;
                },

                toggleOrigin(state, originId) {
                    state.origins[originId].enabled = !state.origins[originId].enabled;
                }
            }
        });
    }
}